<div class="container-fluid">
  <div class="row mt-2">
    <div class="col-12">
      <form *ngIf="complementForm" [formGroup]="complementForm" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-12">
            <h5 class="text-primary">Informations personnelles</h5>
          </div>
        </div>
        <div class="row">
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label class="required">Situation familiale</label>
            <select
              class="form-select"
              formControlName="maritalStatus"
              [class.is-invalid]="submitted && complementForm.controls?.maritalStatus?.errors?.required"
            >
              <option *ngIf="!complementForm.value.maritalStatus" [ngValue]="" selected hidden></option>
              <option *ngFor="let maritalStatus of maritalStatusMap | keyvalue: StringUtils.stringAscOrder" [ngValue]="maritalStatus.key">
                {{ maritalStatus.value }}
              </option>
            </select>
            <small *ngIf="submitted && complementForm.controls?.maritalStatus?.errors?.required" class="form-text text-danger"
              >La situation familiale est requise.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label>Nombre d'enfants</label>
            <input
              type="text"
              class="form-control"
              formControlName="childrenCount"
              maxlength="2"
              [class.is-invalid]="submitted && complementForm.controls?.childrenCount?.errors?.pattern"
            />
            <small *ngIf="submitted && complementForm.controls?.childrenCount?.errors?.pattern" class="form-text text-danger"
              >Seuls les nombres sont autorisés.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label>Nombre de personnes à charge</label>
            <input
              type="text"
              class="form-control"
              formControlName="dependentsNumber"
              maxlength="2"
              [class.is-invalid]="submitted && complementForm.controls?.dependentsNumber?.errors?.pattern"
            />
            <small *ngIf="submitted && complementForm.controls?.dependentsNumber?.errors?.pattern" class="form-text text-danger"
              >Seuls les nombres sont autorisés.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label class="required">Parent isolé </label>
            <div class="mt-1">
              <div class="form-check form-check-inline">
                <input
                  id="singleParentYes"
                  type="radio"
                  class="form-check-input"
                  formControlName="singleParent"
                  name="singleParent"
                  [class.is-invalid]="submitted && complementForm.controls.singleParent.invalid"
                  [value]="true"
                />
                <label for="singleParentYes" class="form-check-label">Oui</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  id="singleParentNo"
                  type="radio"
                  class="form-check-input"
                  formControlName="singleParent"
                  name="singleParent"
                  [class.is-invalid]="submitted && complementForm.controls.singleParent.invalid"
                  [value]="false"
                />
                <label for="singleParentNo" class="form-check-label">Non</label>
              </div>
              <small *ngIf="submitted && complementForm.controls?.singleParent?.errors?.required" class="form-text text-danger"
                >Champ obligatoire</small
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label>Couverture santé</label>
            <select class="form-select" formControlName="healthInsuranceId">
              <option *ngIf="!complementForm.value.healthInsuranceId" [ngValue]="" selected hidden></option>
              <option [ngValue]=""></option>
              <option [ngValue]="healthInsurance.id" *ngFor="let healthInsurance of healthInsurances">
                {{ healthInsurance.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <h5 class="text-primary">Informations de suivi</h5>
          </div>
        </div>
        <div class="row">
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label class="required">Statut du dossier</label>
            <select class="form-select" formControlName="status" [class.is-invalid]="submitted && complementForm.controls?.status?.errors?.required">
              <option *ngIf="!complementForm.value.status" [ngValue]="" selected hidden></option>
              <option *ngFor="let status of folderStatusMap | keyvalue: StringUtils.stringAscOrder" [ngValue]="status.key">
                {{ status.value }}
              </option>
            </select>
            <small *ngIf="submitted && complementForm.controls?.status?.errors?.required" class="form-text text-danger"
              >Le statut du dossier est requis.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label>Date début droit RSA</label>
            <app-datepicker id="fieldRsaRightBeginDate" formControlName="rsaRightBeginDate"></app-datepicker>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <h5 class="text-primary">Accompagnement</h5>
          </div>
        </div>

        <div class="row" formGroupName="supportForm">
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label class="required">Type</label>
            <select
              class="form-select"
              formControlName="supportTypeId"
              [class.is-invalid]="(submitted || supportHistorized) && supportForm.controls?.supportTypeId?.invalid && structureCanUpdateSupport"
            >
              <option value="" selected *ngIf="!supportForm.controls.supportTypeId.value"></option>

              <ng-container *ngFor="let supportType of supportTypes">
                <option
                  *ngIf="
                    !isStructureAndCanUpdateSupOrientation() ||
                    (isStructureAndCanUpdateSupOrientation() && supportType.id === 4) ||
                    (isStructureAndCanUpdateSupOrientation() && supportType.id === 6) ||
                    (isStructureAndCanUpdateSupOrientation() && supportType.id === 8) ||
                    (isStructureAndCanUpdateSupOrientation() && supportType.id === 23)
                  "
                  [ngValue]="supportType.id"
                  [hidden]="([2, 3, 4, 5, 7, 9, 18].includes(supportType.id) && !user.groups.includes('ADMIN')) || [9, 18].includes(supportType.id)"
                >
                  {{ supportType.label }}
                </option>
              </ng-container>
            </select>

            <small *ngIf="(submitted || supportHistorized) && supportForm.controls?.supportTypeId?.errors?.required" class="form-text text-danger"
              >Le type d'accompagnement est requis.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-2">
            <label class="required">Début</label>
            <app-datepicker
              id="fieldBeginDateSupport"
              formControlName="beginDateSupport"
              [invalid]="(submitted || supportHistorized) && (supportForm.controls?.beginDateSupport?.invalid || supportForm.errors?.datesOrder)"
            ></app-datepicker>
            <small
              *ngIf="(submitted || supportHistorized) && supportForm.controls?.beginDateSupport?.errors?.dateFormat"
              class="form-text text-danger"
              >La date de début d'accompagnement est invalide.</small
            >
            <small *ngIf="(submitted || supportHistorized) && supportForm.controls?.beginDateSupport?.errors?.required" class="form-text text-danger"
              >La date de début d'accompagnement est requise.</small
            >
            <small *ngIf="(submitted || supportHistorized) && supportForm.errors?.datesOrder" class="form-text text-danger"
              >La date de début est incohérente avec la date de fin.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-2">
            <label>Fin</label>
            <app-datepicker
              id="fieldEndDateSupport"
              formControlName="endDateSupport"
              [invalid]="(submitted || supportHistorized) && (supportForm.controls?.endDateSupport?.invalid || supportForm.errors?.datesOrder)"
            ></app-datepicker>
            <small *ngIf="(submitted || supportHistorized) && supportForm.controls?.endDateSupport?.errors?.dateFormat" class="form-text text-danger"
              >La date de fin d'accompagnement est invalide.</small
            >
            <small *ngIf="supportHistorized && supportForm.get('endDateSupport').hasError('required')" class="form-text text-danger"
              >La date de fin d'accompagnement est requise pour historiser.</small
            >
            <small *ngIf="(submitted || supportHistorized) && supportForm.errors?.datesOrder" class="form-text text-danger"
              >La date de fin est incohérente avec la date de début.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label>Détail / Motif de fin</label>
            <input type="text" class="form-control" formControlName="typeSupportDetail" />
          </div>

          <div class="mb-3 col-12 col-lg-12 col-xl-2 mt-4" *ngIf="canDisplayHistorizeButton">
            <button
              class="btn btn-primary justify-content-center w-100"
              type="button"
              *appOnlyGroups="['ADMIN', 'TERRITORY', 'DIRECTION+', 'STRUCTURE']"
              (click)="historizeSupport()"
              style="margin-top: 1px"
            >
              Historiser
            </button>
          </div>
        </div>

        <!-- Tableau historique des accompagnements -->
        <div class="card border-0 card-border-radius-0">
          <div class="card-body p-0">
            <div class="table-responsive">
              <div ngbAccordion [closeOthers]="false">
                <div ngbAccordionItem>
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="accordion-button text-secondary" type="button">
                      <span id="supportHistoryTitle">Accompagnements historisées</span>
                    </button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <p *ngIf="!hasHistorizedSupports">Le bénéficiaire n'a aucune historisation d'accompagnement.</p>
                        <div class="col px-0 pt-2" *ngIf="hasHistorizedSupports">
                          <table class="table table-striped table-hover" aria-describedby="supportHistoryTitle">
                            <thead class="text-secondary bg-light">
                              <tr>
                                <th scope="col" class="text-center">Type</th>
                                <th scope="col" class="text-center">Début d'accompagnement</th>
                                <th scope="col" class="text-center">Fin d'accompagnement</th>
                                <th scope="col">Détail</th>
                                <th scope="col" class="text-center"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngFor="let supportHistory of beneficiarySupports">
                                <tr *ngIf="supportHistory.historized">
                                  <td class="text-center">
                                    {{ supportHistory.supportType.label }}
                                  </td>
                                  <td class="text-center">
                                    {{ supportHistory.beginDate | date }}
                                  </td>
                                  <td class="text-center">
                                    {{ supportHistory.endDate | date }}
                                  </td>

                                  <td>
                                    {{ supportHistory.typeSupportDetail }}
                                  </td>
                                  <td class="text-center">
                                    <button
                                      [style.display]="supportHistory.id ? 'block' : 'none'"
                                      type="button"
                                      (click)="
                                        deleteHistorizableItemHistory(
                                          beneficiarySupports,
                                          supportHistory.id,
                                          'Êtes-vous sûr(e) de vouloir supprimer cette historisation d\'accompagnement ?'
                                        )
                                      "
                                      *appOnlyGroups="['ADMIN']"
                                      class="btn btn-sm btn-primary"
                                      ngbTooltip="Supprimer"
                                    >
                                      <fa-icon icon="trash-alt"></fa-icon>
                                    </button>
                                  </td></tr
                              ></ng-container>
                            </tbody>
                          </table>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mx-1 my-3" *appOnlyGroups="['TERRITORY', 'DIRECTION+']">
          <small *ngIf="supportHistoryInvalid" class="form-text text-danger"
            >L'historisation du type d'accompagnement est invalide, veuillez contacter un administrateur.</small
          >
        </div>
        <div class="mx-1 my-3" *appOnlyGroups="['ADMIN']">
          <small *ngIf="isInvalidSupport" class="form-text text-danger"
            >L'historisation du type d'accompagnement est invalide, veuillez supprimer les lignes incohérentes et re-créer l'historisation à l'aide de
            l'accompagnement actuel.</small
          >
        </div>

        <div class="row mt-3" formGroupName="intensityForm">
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label for="intensity">Intensité</label>
            <select
              id="intensity"
              class="form-select"
              formControlName="intensityId"
              [class.is-invalid]="submitted && intensityForm.controls?.intensityId?.errors?.required"
            >
              <option [ngValue]=""></option>
              <option *ngFor="let intensity of intensities" [ngValue]="intensity.id">
                {{ intensity.key }}
              </option>
            </select>
            <small
              *ngIf="(submitted || referentHistorized || orientationHistorized) && intensityForm.controls?.intensityId.errors?.required"
              class="form-text text-danger"
              >L'intensité est requise.</small
            >
          </div>

          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-2">
            <label for="fieldBeginDate">Début</label>
            <app-datepicker
              id="fieldBeginDate"
              formControlName="beginDate"
              [invalid]="submitted && (intensityForm.controls?.beginDate?.invalid || intensityForm.errors?.datesOrder)"
            ></app-datepicker>
            <small *ngIf="submitted && intensityForm.controls?.beginDate?.errors?.dateFormat" class="form-text text-danger"
              >La date de début de l'intensité est invalide.</small
            >
            <small *ngIf="submitted && intensityForm.controls?.beginDate?.errors?.required" class="form-text text-danger"
              >La date de début de l'intensité est requise.</small
            >
            <small *ngIf="submitted && intensityForm.errors?.datesOrder" class="form-text text-danger"
              >La date de début est incohérente avec la date de fin.</small
            >
          </div>

          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-2">
            <label for="fieldIntensityEndDate">Fin</label>
            <app-datepicker
              id="fieldIntensityEndDate"
              formControlName="endDate"
              [invalid]="intensityForm.controls?.endDate?.invalid || intensityForm.errors?.datesOrder"
            ></app-datepicker>
            <small *ngIf="intensityForm.controls?.endDate?.errors?.dateFormat" class="form-text text-danger"
              >La date de fin de l'intensité est invalide.</small
            >
            <small *ngIf="intensityForm.errors?.datesOrder" class="form-text text-danger"
              >La date de fin est incohérente avec la date de début.</small
            >
            <small *ngIf="intensityForm.value.endDate && !supportForm.getRawValue().endDateSupport" class="form-text text-danger"
              >Il ne peut pas y avoir de date de fin d'intensité si il n'y a pas de date de fin d'accompagnement.</small
            >
            <small *ngIf="intensityForm.value.endDate && intensityForm.value.endDate < supportForm.value.endDateSupport" class="form-text text-danger"
              >Il ne peut pas y avoir une date de fin d'intensité < à la date de fin d'accompagnement.</small
            >
          </div>

          <div class="mb-3 col-12 col-lg-12 col-xl-3 mt-3"></div>

          <div class="mb-3 col-12 col-lg-12 col-xl-2 mt-4">
            <button
              class="btn btn-primary justify-content-center w-100"
              type="button"
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
              (click)="historizeIntensity()"
              style="margin-top: 1px"
            >
              Historiser
            </button>
          </div>
        </div>

        <!-- Tableau historique des intensités -->
        <div class="card border-0 card-border-radius-0">
          <div class="card-body p-0">
            <div class="table-responsive">
              <div ngbAccordion [closeOthers]="false">
                <div ngbAccordionItem>
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="accordion-button text-secondary" type="button">
                      <span id="intensityHistoryTitle">Intensités historisées</span>
                    </button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <p *ngIf="!hasHistorizedIntensities">Le bénéficiaire n'a aucune historisation d'intensité.</p>
                        <div class="col px-0 pt-2" *ngIf="hasHistorizedIntensities">
                          <table class="table table-striped table-hover" aria-describedby="intensityHistoryTitle">
                            <thead class="text-secondary bg-light">
                              <tr>
                                <th scope="col" class="text-center">Début</th>
                                <th scope="col" class="text-center">Fin</th>
                                <th scope="col" class="text-center">Intensité</th>
                                <th scope="col" class="text-center"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngFor="let intensity of beneficiaryIntensities">
                                <tr *ngIf="intensity.historized">
                                  <td class="text-center">
                                    {{ intensity.beginDate | date }}
                                  </td>
                                  <td class="text-center">
                                    {{ intensity.endDate | date }}
                                  </td>

                                  <td class="text-center">
                                    {{ intensity.intensity.key }}
                                  </td>
                                  <td class="text-center">
                                    <button
                                      type="button"
                                      (click)="
                                        deleteHistorizableItemHistory(
                                          beneficiaryIntensities,
                                          intensity.id,
                                          'Êtes-vous sûr(e) de vouloir supprimer cette historisation d\'intensité ?'
                                        )
                                      "
                                      *appOnlyGroups="['ADMIN']"
                                      class="btn btn-sm btn-primary"
                                      ngbTooltip="Supprimer"
                                    >
                                      <fa-icon icon="trash-alt"></fa-icon>
                                    </button>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mx-1 my-3">
          <small *ngIf="intensityHistoryInvalid" class="form-text text-danger"
            >L'historisation de l'intensité du bénéficiaire est invalide, veuillez supprimer les lignes incohérentes et re-créer
            l'historisation.</small
          >
        </div>

        <div class="row mt-4">
          <div class="col">
            <h5 class="text-primary">Orientation</h5>
          </div>
        </div>
        <div class="row" formGroupName="orientationForm">
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label>Structure</label>
            <select
              class="form-select"
              formControlName="structureId"
              [class.is-invalid]="(submitted || orientationHistorized) && orientationForm.controls?.structureId?.invalid"
            >
              <option *ngIf="!orientationForm.value.structureId" [ngValue]="" selected hidden></option>
              <option
                *ngFor="let structure of structures"
                [ngValue]="structure.id"
                [disabled]="!structure.active || structure.id === beneficiaryStructureWithoutBeneficiarySupport?.id"
              >
                {{ structure.label }}
              </option>
            </select>
            <small *ngIf="orientationHistorized && orientationForm.get('structureId').hasError('required')" class="form-text text-danger"
              >La structure est requise pour historiser.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-2">
            <label class="required">Début</label>
            <app-datepicker
              id="fieldOrientationBeginDate"
              formControlName="orientationBeginDate"
              [invalid]="
                (submitted || orientationHistorized) &&
                (orientationForm.errors?.datesOrder || orientationForm.controls?.orientationBeginDate?.invalid)
              "
            ></app-datepicker>
            <small
              *ngIf="(submitted || orientationHistorized) && orientationForm.controls?.orientationBeginDate?.errors?.required"
              class="form-text text-danger"
              >La date de début d'orientation est requise.</small
            >
            <small *ngIf="(submitted || orientationHistorized) && orientationForm.errors?.datesOrder" class="form-text text-danger"
              >La date de début est incohérente avec la date de fin.</small
            >
            <small
              *ngIf="(submitted || orientationHistorized) && orientationForm.controls?.orientationBeginDate?.errors?.dateFormat"
              class="form-text text-danger"
              >La date de début d'orientation est invalide.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-2">
            <label>Fin</label>
            <app-datepicker
              id="fieldOrientationEndDate"
              formControlName="orientationEndDate"
              (change)="resetValidator()"
              [invalid]="
                (submitted || orientationHistorized) &&
                (orientationForm.errors?.datesOrder ||
                  orientationForm.errors?.endDateAndReason ||
                  orientationForm.controls?.orientationEndDate?.invalid)
              "
            ></app-datepicker>
            <small *ngIf="(submitted || orientationHistorized) && orientationForm.errors?.endDateAndReason" class="form-text text-danger"
              >La date de fin d'orientation est requise.</small
            >
            <small *ngIf="(submitted || orientationHistorized) && orientationForm.errors?.datesOrder" class="form-text text-danger"
              >La date de fin est incohérente avec la date de début.</small
            >
            <small
              *ngIf="(submitted || orientationHistorized) && orientationForm.controls?.orientationEndDate?.errors?.dateFormat"
              class="form-text text-danger"
              >La date de fin est invalide.</small
            >
            <small *ngIf="orientationHistorized && orientationForm.controls?.orientationEndDate?.errors?.required" class="form-text text-danger"
              >La date de fin d'orientation est requise pour historiser.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label>Motif de fin</label>
            <select
              class="form-select"
              formControlName="reasonOrientationEnding"
              [class.is-invalid]="
                (submitted || orientationHistorized) &&
                (orientationForm.errors?.endDateAndReason || orientationForm.controls.reasonOrientationEnding.invalid)
              "
            >
              <option *ngIf="!orientationForm.value.reasonOrientationEnding" [ngValue]="" selected hidden></option>
              <option [ngValue]=""></option>
              <option
                *ngFor="let reasonOrientationEnding of reasonOrientationEndingMap | keyvalue: StringUtils.stringAscOrder"
                [hidden]="['HealthOrFamillyObligation', 'SupportSuspension'].includes(reasonOrientationEnding.key)"
                [ngValue]="reasonOrientationEnding.key"
              >
                {{ reasonOrientationEnding.value }}
              </option>
            </select>
            <small *ngIf="(submitted || orientationHistorized) && orientationForm.errors?.endDateAndReason" class="form-text text-danger"
              >Le motif de fin d'orientation est requis.</small
            >
          </div>
          <div class="mb-3 col-12 col-lg-12 col-xl-2 mt-4">
            <button
              class="btn btn-primary justify-content-center w-100"
              type="button"
              (click)="historizeOrientation()"
              *appOnlyGroups="['ADMIN', 'TERRITORY', 'DIRECTION+']"
              style="margin-top: 1px"
            >
              Historiser
            </button>
          </div>
        </div>
        <!-- Tableau historique des orientations -->
        <div class="card border-0 card-border-radius-0">
          <div class="card-body p-0">
            <div class="table-responsive">
              <div ngbAccordion [closeOthers]="false">
                <div ngbAccordionItem>
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="accordion-button text-secondary" type="button">
                      <span id="orientationHistoryTitle">Orientations historisées</span>
                    </button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <p *ngIf="!hasHistorizedOrientations">Le bénéficiaire n'a aucune historisation d'orientation.</p>
                        <div class="col px-0 pt-2" *ngIf="hasHistorizedOrientations">
                          <table class="table table-striped table-hover" aria-describedby="orientationHistoryTitle">
                            <thead class="text-secondary bg-light">
                              <tr>
                                <th scope="col" class="text-center">Structure</th>
                                <th scope="col" class="text-center">Début d'orientation</th>
                                <th scope="col" class="text-center">Fin d'orientation</th>
                                <th scope="col">Motif de fin d'orientation</th>
                                <th scope="col" class="text-center"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngFor="let orientationHistory of beneficiaryOrientations">
                                <tr *ngIf="orientationHistory.historized">
                                  <td class="text-center">
                                    {{ orientationHistory.structure.label }}
                                  </td>
                                  <td class="text-center">
                                    {{ orientationHistory.beginDate | date }}
                                  </td>
                                  <td class="text-center">
                                    {{ orientationHistory.endDate | date }}
                                  </td>

                                  <td>
                                    {{ reasonOrientationEndingMap.get(orientationHistory.reasonOrientationEnding) }}
                                  </td>
                                  <td class="text-center">
                                    <button
                                      [style.display]="orientationHistory.id ? 'block' : 'none'"
                                      type="button"
                                      (click)="
                                        deleteHistorizableItemHistory(
                                          beneficiaryOrientations,
                                          orientationHistory.id,
                                          'Êtes-vous sûr(e) de vouloir supprimer cette historisation d\'orientation ?'
                                        )
                                      "
                                      *appOnlyGroups="['ADMIN']"
                                      class="btn btn-sm btn-primary"
                                      ngbTooltip="Supprimer"
                                    >
                                      <fa-icon icon="trash-alt"></fa-icon>
                                    </button>
                                  </td></tr
                              ></ng-container>
                            </tbody>
                          </table>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mx-1 my-3" *appOnlyGroups="['TERRITORY', 'DIRECTION+']">
          <small *ngIf="orientationHistoryInvalid" class="form-text text-danger"
            >L'historisation des orientations est invalide, veuillez contacter un administrateur.</small
          >
        </div>
        <div class="mx-1 my-3" *appOnlyGroups="['ADMIN']">
          <small *ngIf="orientationHistoryInvalid" class="form-text text-danger"
            >L'historisation des orientations est invalide, veuillez supprimer les lignes incohérentes et re-créer l'historisation à l'aide de
            l'orientation actuelle.</small
          >
        </div>

        <div class="row mt-3" formGroupName="referentForm">
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
            <label>Référent</label>
            <select
              class="form-select"
              (change)="referentOnChange()"
              formControlName="referent"
              [class.is-invalid]="(submitted || referentHistorized || orientationHistorized) && referentForm.controls?.referent?.errors?.required"
            >
              <option *ngIf="!complementForm.value.referent" [ngValue]="" selected hidden></option>
              <option *appOnlyGroups="['ADMIN']" [ngValue]=""></option>
              <option *ngFor="let referent of userList" [ngValue]="referent.id">
                {{ referent.name }}
              </option>
            </select>
            <small
              *ngIf="(submitted || referentHistorized || orientationHistorized) && referentForm.controls?.referent?.errors?.required"
              class="form-text text-danger"
              >Le référent est requis.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-2">
            <label>Début</label>
            <app-datepicker
              id="fieldBeginDate"
              (change)="beginDateReferentOnChange()"
              formControlName="beginDateReferent"
              [invalid]="
                (submitted || referentHistorized || orientationHistorized) &&
                (referentForm.controls?.beginDateReferent?.invalid || referentForm.errors?.datesOrder)
              "
            ></app-datepicker>
            <small
              *ngIf="(submitted || referentHistorized || orientationHistorized) && referentForm.controls?.beginDateReferent?.errors?.dateFormat"
              class="form-text text-danger"
              >La date de début de référent est invalide.</small
            >
            <small
              *ngIf="(submitted || referentHistorized || orientationHistorized) && referentForm.controls?.beginDateReferent?.errors?.required"
              class="form-text text-danger"
              >La date de début de référent est requise.</small
            >
            <small *ngIf="(submitted || referentHistorized) && referentForm.errors?.datesOrder" class="form-text text-danger"
              >La date de début est incohérente avec la date de fin.</small
            >
          </div>
          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-2">
            <label>Fin</label>
            <app-datepicker
              id="fieldEndDate"
              formControlName="endDateReferent"
              [invalid]="(submitted || referentHistorized) && (referentForm.controls?.endDateReferent?.invalid || referentForm.errors?.datesOrder)"
            ></app-datepicker>
            <small
              *ngIf="(submitted || referentHistorized) && referentForm.controls?.endDateReferent?.errors?.dateFormat"
              class="form-text text-danger"
              >La date de fin de référent est invalide.</small
            >
            <small *ngIf="referentHistorized && referentForm.get('endDateReferent').hasError('required')" class="form-text text-danger"
              >La date de fin de référent est requise pour historiser.</small
            >
            <small *ngIf="(submitted || referentHistorized) && referentForm.errors?.datesOrder" class="form-text text-danger"
              >La date de fin est incohérente avec la date de début.</small
            >
          </div>
          <div class="mb-3 col-12 col-lg-12 col-xl-3 mt-3"></div>
          <div class="mb-3 col-12 col-lg-12 col-xl-2 mt-4">
            <button
              class="btn btn-primary justify-content-center w-100"
              type="button"
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
              (click)="historizeReferent()"
              style="margin-top: 1px"
            >
              Historiser
            </button>
          </div>
        </div>

        <!-- Tableau historique des référents -->
        <div class="card border-0 card-border-radius-0">
          <div class="card-body p-0">
            <div class="table-responsive">
              <div ngbAccordion [closeOthers]="false">
                <div ngbAccordionItem>
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="accordion-button text-secondary" type="button">
                      <span id="referentHistoryTitle">Référents historisés</span>
                    </button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <p *ngIf="!hasHistorizedReferent">Le bénéficiaire n'a aucune historisation de référent.</p>
                        <div class="col px-0 pt-2" *ngIf="hasHistorizedReferent">
                          <table class="table table-striped table-hover" aria-describedby="referentHistoryTitle">
                            <thead class="text-secondary bg-light">
                              <tr>
                                <th scope="col" class="text-center">Début</th>
                                <th scope="col" class="text-center">Fin</th>
                                <th scope="col" class="text-center">Structure</th>
                                <th scope="col" class="text-center">Référent</th>
                                <th scope="col" class="text-center"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngFor="let referent of beneficiaryReferents">
                                <tr *ngIf="referent.type === 'GLOBAL' && referent.historized">
                                  <td class="text-center">
                                    {{ referent.beginDate | date }}
                                  </td>
                                  <td class="text-center">
                                    {{ referent.endDate | date }}
                                  </td>
                                  <td class="text-center">
                                    {{ referent.user.structureLabel }}
                                  </td>
                                  <td class="text-center">
                                    {{ referent.user.name }}
                                  </td>
                                  <td class="text-center">
                                    <button
                                      [style.display]="referent.id ? 'block' : 'none'"
                                      type="button"
                                      (click)="
                                        deleteHistorizableItemHistory(
                                          beneficiaryReferents,
                                          referent.id,
                                          'Êtes-vous sûr(e) de vouloir supprimer cette historisation de référent ?'
                                        )
                                      "
                                      *appOnlyGroups="['ADMIN']"
                                      class="btn btn-sm btn-primary"
                                      ngbTooltip="Supprimer"
                                    >
                                      <fa-icon icon="trash-alt"></fa-icon>
                                    </button>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mx-1 my-3" *appOnlyGroups="['STRUCTURE', 'DIRECTION+']">
          <small *ngIf="referentHistoryInvalid" class="form-text text-danger"
            >L'historisation de référent du bénéficiaire est invalide, veuillez contacter un administrateur.</small
          >
        </div>
        <div class="mx-1 my-3" *appOnlyGroups="['ADMIN']">
          <small *ngIf="referentHistoryInvalid" class="form-text text-danger"
            >L'historisation de référent du bénéficiaire est invalide, veuillez supprimer les lignes incohérentes et re-créer l'historisation à l'aide
            du référent actuel.</small
          >
        </div>
        <!-- Boutons actions -->
        <div class="row mx-0 my-4">
          <div class="d-grid ms-auto col-md-6 col-3 col-lg-3 col-xl-2 px-0" *appProfilePerimeter>
            <button
              class="btn btn-primary d-flex justify-content-center"
              type="button"
              (click)="cancel()"
              *appOnlyGroups="['ADMIN', 'TERRITORY', 'STRUCTURE', 'DIRECTION+']"
            >
              <fa-icon icon="ban"></fa-icon>
              <span class="ms-2 d-none d-md-block">Annuler</span>
            </button>
          </div>
          <div class="d-grid col-3 col-md-6 col-lg-3 col-xl-2 pe-0" *appProfilePerimeter>
            <button
              class="btn btn-primary d-flex justify-content-center"
              type="submit"
              *appOnlyGroups="['ADMIN', 'TERRITORY', 'STRUCTURE', 'DIRECTION+']"
            >
              <fa-icon icon="save"></fa-icon>
              <span class="ms-2 d-none d-md-block">Sauvegarder</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
